import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { useReports } from 'lib/hooks/queries/reports/useReports';

import { TABS } from '../../lib/constants';

import ErrorList from './components/ErrorList';
import NoReports from './components/NoReports';
import ReportItem from './components/ReportItem/ReportItem';
import ReportListSkeleton from './components/ReportListSkeleton';

const ReportListView = ({ useData }) => {
  const [searchParams] = useSearchParams();

  const category = searchParams.get('category') || TABS[0].value;

  const enabled = !!useData || !!category;

  const { data, isLoading, isError, refetch } = (useData || useReports)({
    params: { category },
    dependencies: category ? [category] : [],
    options: { enabled }
  });

  const reports = data?.reports || [];

  if (isLoading) return <ReportListSkeleton />;

  if (isError) return <ErrorList refetch={refetch} />;

  if (!reports.length) return <NoReports />;

  return (
    <div className="grid grid-cols-1 gap-4 overflow-y-auto p-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {reports.map((report) => (
        <ReportItem key={report.id} report={report} category={category} />
      ))}
    </div>
  );
};

export default ReportListView;
